import React from 'react';

const TimelineSection: React.FC = () => {
  return (
    <section className="bg-[#F6F6F6] py-16 px-4">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        {/* Main Title */}
        <div className="max-w-[970px] mx-auto">
          <h1 className="font-bold text-center w-full lg:text-[40px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%] lg:mb-20 mb-10">
          The Right Person with the Right Perspective at the Right Time
        </h1>
        </div>
        
        {/* Timeline Container */}
        <div className="max-w-[970px] mx-auto relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-[0.5px] h-full bg-black"></div>
          
          {/* Timeline Items */}
          <div className="space-y-6 md:space-y-10">
            {/* Item 1 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    Rob's track record as a mining investor and advisor is impeccable
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 2 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    Consider these highlights of his 20-year investment career...
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 3 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    In June 2008, he made the right call that markets would tank. He went against them. And he was proven right within three months.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 4 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    When he ran a hedge fund for one of Canada's banks, his wealthy investors realized an annualized return of 40% a year.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 5 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    If you count his short positions as well as the long ones, his fund doubled its capital every year.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 6 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    In June 2019, he bought shares of West Vault Mining and sold them a year later for a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">400% gain</span>.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 7 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    In October 2023, he recommended shares of Agnico Eagle... and scored a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">150% return in less than two years</span>.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 8 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    Rob went long on Glentel, Inc. at $1.73—and it was acquired at $26.50. That's a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">1,431% return</span>.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 9 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    He generated a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">9,400% return</span> on the shares of Absolute Software. The company's stock price went from $0.40 to $38...
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 10 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    He booked a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">3,700% gain</span> on Catamaran Corp. when the company's share price went from $2 to $76.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 11 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    Rob personally turned around a struggling miner, AbraSilver, and the company's market capitalization went from $5 million to $1 billion.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
            
            {/* Item 11 */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8"></div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    The company's shareholders who believed in Rob's vision booked a <span className="font-bold text-[#192842] md:text-[35px] text-[20px]">2,000% gain</span>.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Item 12 - Concluding Statement */}
            <div className="flex items-center">
              <div className="w-1/2 pr-4 md:pr-8 text-right">
                <div className="">
                  <p className="text-[#192842] md:text-[22px] text-[16px] font-[400]">
                    And now Rob is ready to bring his knowledge and his stellar track record to you.
                  </p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full z-10" style={{backgroundColor: '#D4A129'}}></div>
              <div className="w-1/2 pl-4 md:pl-8"></div>
            </div>
          </div>
        </div>
        
        {/* Call-to-Action Button */}
        <div className="text-center mt-12">
          <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block">
            <button className="bg-[#0B6054] text-white font-bold py-4 lg:px-44 px-10 w-full lg:w-auto rounded-lg lg:text-lg  uppercase tracking-wide transition-colors duration-300 shadow-lg hover:shadow-xl">
              GET ROB'S UPDATES IN YOUR INBOX
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
